import React from 'react';

const Footer = () => {
    return (
        <div>
            <div className='bg-slate-900 h-40 w-screen mt-20 md:mt-24 md:h-48 flex flex-col justify-center items-center text-white'>
                <p className='text-lg mt-20'>A noobie QuizQuark Web Application</p>
                <p className='text-bold text-sm'>Developed By ⒸShoaib Ahammed, 2022</p>
            </div>
        </div>
    );
};

export default Footer;